import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { formatedDate } from "../../../../utils/date-utils";
import { useIsFranchisLogin } from "../../../../utils/userRoles";

function OrderWisePaymentItem(props){
  const isFranchise=useIsFranchisLogin();
    const[data]=useState(props.item)
    const navigate=useNavigate();
    const  navigatePaymentsDetailPage=()=>{
        navigate("/franchisePayments",{state:{storeId:data.storeId}})
    }

    const orderDetailFynctionality = () => {
      //dispatch(updateFormInfo({ displayForm: false, formData: { order } }));
  
      navigate("/orderDetails", { state: { order: {
        id:data.order_id
      }, from: "order" } });
    };

    function Temp(status) {
    switch (status) {
      // case "0":
      //   return <span style={{ color: "black" }}>Pending</span>;

      // case "1":
      //   return <span style={{ color: "pinkAccent" }}>Accepted</span>;

      // case "2":
      //   return <span style={{ color: "blueAccent" }}>Assigned</span>;

      // case "3":
      //   return <span style={{ color: "yellow" }}>Picked Up</span>;
      case "4":
        return <span style={{ color: "green" }}>Delivered</span>;
      // case "5":
      //   return <span style={{ color: "green" }}>Delivered</span>;
      case "6":
        return <span style={{ color: "red" }}>Cancelled</span>;
        break;
      default :
         return <span>__</span>

      // case "7":
      //   return <span style={{ color: "black" }}>Rejected</span>;
      // case "8":
      //   return (
      //     <span style={{ color: "0xffcc0d0d" }}>Order Cancel Request</span>
      //   );
    }
  }

    return(
        <>
        <tr>
        {/* <td>{data.order_id}</td> */}
       
        {/* <td>#Svr210524</td> */}
        <td>
          {data.duration}
          </td>
         
            {
        !isFranchise?<td
        onClick={() => {
          orderDetailFynctionality();
        }}
      >
        <Link className="anchor-color-change">#EP0{data.order_id}</Link>
      </td>:<td>#EP0{data.order_id}</td>
      }
         
        {/* <td onClick={()=>storeInfoPage()}>
          <Link>{data.storeName}</Link>
        </td> */}
        {/* <td>{data.orders_count}</td> */}
        <td>₹{data.orderPayment}</td>
        
        
        <td>₹{(+data.storePayment)-(+data.tax)
        }</td>
        <td>{data.tax}</td>
        <td>₹{data.appPayment }</td>
        <td>₹{data.deliveryCharges}</td>
        <td>₹{data.packageCharge}</td>

<td>₹{data.platformFee}</td>
<td>₹{data.couponCost}</td>
<td>₹{data.finalPayShare}</td>
{/* ({data.final_app_amount}) */}
<td>{Temp(data.status)}</td>
<td>₹{data.foPayment}</td>
{/* <td>{data.payment_status}</td> */}

        
        
        {/* <td>{data.transaction_date}</td>
        <td>{data.transaction_id}</td> */}
      </tr>
        </>
    )
}
export default OrderWisePaymentItem;